import { components, services } from '@/utils'

import RowWithMessageTypeIcon from '@/components/misc/RowWithMessageTypeIcon'
import rulesTemplate from '@/components/rules/template'
import { ruleTags, ruleTypes } from '@/components/rules/utils'
import selectorSendername from '@/components/selector/sendername'
import nameField from '@/components/services/otp-settings/commons/form/name'

const serviceNameViaPoint = services['otp-settings/templates'].split('/').join('.')
const serviceNameKebab = services['otp-settings/templates'].split('/').join('-')

function renderNameField(h) {
  return h(
    nameField,
    {
      props: {
        value: this.proxy.name,
        isNew: this.isNew,
        disabled: this.disabled,
        service: serviceNameViaPoint
      },
      on: {
        input: event => {
          this.proxy.name = event
        }
      }
    }
  )
}
function renderSenderNameField(h) {
  return h(
    selectorSendername,
    {
      props: {
        value: this.proxy.additionalSettings.senderId,
        type: this.proxy.channelType,
        disabled: this.disabled,
        itemValue: 'id',
        dense: true
      },
      on: {
        input: event => {
          this.proxy.additionalSettings.senderId = event
        }
      }
    }
  )
}
function renderChannelTypeField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.channelType,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.channelType`),
        items: this.channelTypes,
        disabled: this.disabled,
        dense: true,
        details: false,
        required: true
      },
      on: {
        input: event => {
          this.proxy.channelType = event
        }
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                value: item.value,
                title: item.title
              }
            }
          )
        },
        item: ({ item }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                value: item.value,
                title: item.title,
                as: 'text'
              }
            }
          )
        }
      }
    }
  )
}
function renderTemplateField(h) {
  return h(
    components.textarea,
    {
      props: {
        value: this.proxy.additionalSettings.template,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.additionalSettings.template`),
        hint: this.getTranslate(`${serviceNameViaPoint}.hints.additionalSettings.template`),
        disabled: this.disabled,
        dense: true,
        required: true
      },
      on: {
        input: event => {
          this.proxy.additionalSettings.template = event
        }
      }
    }
  )
}

function renderConditions(h) {
  return h(
    rulesTemplate,
    {
      props: {
        value: this.proxy.conditions,
        whitelist: [ ruleTags.recipient, ruleTags.mccmnc, ruleTags.contactList, ruleTags.group ],
        ruleType: ruleTypes.conditions
      },
      on: {
        input: event => {
          this.proxy.conditions = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${serviceNameKebab}-form`]: true,
        [`${serviceNameKebab}-form--new`]: this.isNew
      }
    },
    [
      h(
        'div',
        {
          class: {
            'grid grid-gap--12': true,
            'grid-cols--2': this.viewport.breakpoint.mdUp
          }
        },
        [
          renderNameField.call(this, h),
          renderChannelTypeField.call(this, h),
          renderSenderNameField.call(this, h)
        ]
      ),
      renderTemplateField.call(this, h),
      renderConditions.call(this, h)
    ]
  )
}
